<template>
  <div class="w-full h-full relative">
    <O3D v-if="renderer" class="">
      <O3D :py="-10.5">
        <CamControl @ready="isReady = true"></CamControl>
      </O3D>
      <!-- <CodeBuilding></CodeBuilding> -->
      <CodeBuildingLayout></CodeBuildingLayout>
    </O3D>
  </div>
</template>

<script>
import { RenderRoot } from '../Reusable/RenderRoot'
import { PCamera } from '../Reusable/PCamera'
// import { CubeCam } from '../Reusable/CubeCam'
import { Scene, Color } from 'three'
// import { ShaderCubeChromatics } from '../Reusable/ShaderCubeChromatics'
export default {
  mixins: [RenderRoot],
  components: {
  },
  data () {
    return {
      composer: false,
      useBloom: false,
      isReady: false,
      // layouts: {
      //   flower: false
      // },
      renderer: false,
      camera: false,
      scene: new Scene(),
      shaderCube: false
    }
  },
  methods: {
    setup () {
      this.camera = new PCamera({ element: this.renderRootElement, onResize: this.onResize })
      this.scene.add(this.o3d)
    },
    // setupGUI () {
    //   if (this.useBloom && process.env.NODE_ENV === 'development' && window.innerWidth > 500) {
    //     const dat = require('dat.gui')
    //     const gui = new dat.GUI()
    //     // gui.domElement.style.position = 'absolute'
    //     // gui.domElement.style.top = '0px'
    //     // gui.domElement.style.right = '0px'
    //     // this.element.appendChild(gui.domElement)

    //     // this.addEventListener('reset-cam', () => {
    //     //   gui.updateDisplay()
    //     // })
    //     this.onClean(() => {
    //       gui.destroy()
    //     })
    //     gui.add(this.Bloom, 'threshold')
    //     gui.add(this.Bloom, 'strength')
    //     gui.add(this.Bloom, 'radius')
    //     let copy2clip = require('copy-to-clipboard')
    //     let copy = () => {
    //       copy2clip(`
    //     exposure: ${this.Bloom.exposure},
    //     bloomStrength: ${this.Bloom.bloomStrength},
    //     bloomThreshold: ${this.Bloom.bloomThreshold},
    //     bloomRadius: ${this.Bloom.bloomRadius}
    //       `)
    //     }
    //     gui.add({ copy }, 'copy')
    //   }
    // },
    // setupBloom () {
    //   if (!this.useBloom) {
    //     return
    //   }
    //   /* BLOOM START */
    //   let { Vector2 } = require('three/src/math/Vector2')
    //   let { EffectComposer } = require('three/examples/jsm/postprocessing/EffectComposer')
    //   let { RenderPass } = require('three/examples/jsm/postprocessing/RenderPass')
    //   let { UnrealBloomPass } = require('three/examples/jsm/postprocessing/UnrealBloomPass')
    //   var Params = {
    //     exposure: 1,
    //     bloomStrength: 1.2,
    //     bloomThreshold: 0.985,
    //     bloomRadius: 1.3
    //   }

    //   let renderer = this.ctx.renderer
    //   let element = this.ctx.renderRootElement
    //   let rect = element.getBoundingClientRect()
    //   var renderScene = new RenderPass(this.ctx.scene, this.ctx.camera)
    //   let dpi = window.devicePixelRatio || 1.0
    //   var bloomPass = new UnrealBloomPass(new Vector2(rect.width * dpi, rect.height * dpi), 1.5, 0.4, 0.85)
    //   this.Bloom = bloomPass
    //   bloomPass.threshold = Params.bloomThreshold
    //   bloomPass.strength = Params.bloomStrength
    //   bloomPass.radius = Params.bloomRadius

    //   this.composer = new EffectComposer(renderer)
    //   this.composer.addPass(renderScene)
    //   this.composer.addPass(bloomPass)
    //   this.onResize(() => {
    //     let rect = element.getBoundingClientRect()
    //     let dpi = 1
    //     bloomPass.setSize(rect.width * dpi, rect.height * dpi)
    //     renderScene.setSize(rect.width * dpi, rect.height * dpi)
    //   })

    //   this.$on('syncBloom', () => {
    //     if (this.useBloom) {
    //       this.$emit('composer', this.composer)
    //     } else {
    //       this.$emit('composer', false)
    //     }
    //   })

    //   this.$watch('useBloom', () => {
    //     this.$emit('syncBloom')
    //   })
    //   this.$emit('syncBloom')
    //   /* BLOOM END */
    // },
    setupComputeResources () {
      // this.shaderCubeChromatics = new ShaderCubeChromatics({
      //   res: 128,
      //   renderer: this.ctx.renderer,
      //   loop: this.onLoop,
      //   color: new Color('#ffffff')
      // })

      // this.cubeCam = new CubeCam({
      //   res: 256,
      //   renderer: this.ctx.renderer,
      //   scene: this.ctx.scene,
      //   camera: this.ctx.camera,
      //   loop: this.onLoop,
      //   clean: this.onClean
      // })
    }
  },
  mounted () {
    this.setup()
    // this.setupBloom()
    // this.setupGUI()
    // this.setupComputeResources()

    this.scene.background = new Color('#eeeeee') // new TextureLoader().load(require('./img/skyspace.jpg'))

    // this.scene.background = new TextureLoader().load(require('./img/stained-glass.jpg'))

    // this.renderRootElement.style.backgroundImage = `url('${require('./img/stained-glass.jpg')}')`
    // // this.renderRootElement.style.backgroundImage = `url('${require('./img/skyspace.jpg')}')`
    // this.renderRootElement.style.backgroundSize = `cover`
    // this.renderRootElement.style.backgroundColor = `black`
    // this.renderRootElement.style.backgroundPosition = `center center`
    // this.renderRootElement.style.backgroundRepeat = `no-repeat no-repeat`
  },
  beforeDestroy () {
    // this.renderRootElement.style.backgroundSize = ``
    // this.renderRootElement.style.backgroundImage = ``
    // this.renderRootElement.style.backgroundColor = ``
    // this.renderRootElement.style.backgroundPosition = ``
    // this.renderRootElement.style.backgroundRepeat = ``
  }
}
</script>

<style>
</style>
